import * as React from 'react';

// Components
import VersionNumber from '../../../VersionNumber';
import AltLoginLink from '../../../AltLoginLink';

// Utils & Constants
import { Layout, useResponsiveLayout } from '@shopee-user/layout-responsive';

// Types
import { LoginByOtpOneCredentialOptionalRequireAuthKeyProps } from '@shopee-user/business-customization-types';

import styles from './style.scss';

function _Footer(_: LoginByOtpOneCredentialOptionalRequireAuthKeyProps) {
  const { layout } = useResponsiveLayout();

  const MobileVersionNumber = layout === Layout.Mobile && (
    <VersionNumber className={styles.versionNumber} />
  );

  const DesktopAltLoginLink = layout === Layout.Desktop && <AltLoginLink />;
  return (
    <>
      {DesktopAltLoginLink}
      {MobileVersionNumber}
    </>
  );
}

export const Footer = _Footer;
